export default function MobileCTA() {
  return (
    <div className="fixed inset-x-0 bottom-0 z-40 border-t border-foreground-800 bg-foreground-950/95 backdrop-blur md:hidden">
      <div className="grid grid-cols-3 gap-2 px-3 py-3">
        <a href="#products" className="btn-primary h-11">
          Shop
        </a>
        <a href="tel:07909324302" className="btn-light-outline h-11">
          <i className="ri-phone-line"></i> Call
        </a>
        <a href="#visit" className="btn-light-outline h-11">
          Visit
        </a>
      </div>
    </div>
  );
}